import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import DeadLeads from "../../../components/deadLeads/dead"

const AllDeadLeads = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dead Leads | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <DeadLeads />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default AllDeadLeads
